import BasePopup from '../Base/BasePopup';
export default BasePopup;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree-select/es/Popup/MultiplePopup.js
// module id = 1565
// module chunks = 3